<div class="container">
    <img src="assets/CoverMyMeds_Logo_Screens.png"
        width="600px" height="101px" priority class="center">
    <mat-label class="custom-label">
        The information
        contained herein is proprietary and may only be used in connection with
        CoverMyMeds<br>services for internal review and analysis of claims submitted.&nbsp; It
        may not be reproduced in any manner<br>or used for any other purposes.
    </mat-label>
</div>